import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { toast } from "react-toastify";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import PageHelpGuide from "../../components/PageHelpGuide";
import { CAMPAIGNS_CONFIG_HELP_DATA } from "../../constants/pageHelp/campaignsConfigHelp";
import { getStandardButtonStyles } from "../../styles/standardButtons";
import api from "../../services/api";
import usePlans from "../../hooks/usePlans";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  FormHelperText,
} from "@material-ui/core";
import ConfirmationModal from "../../components/ConfirmationModal";
import ForbiddenPage from "../../components/ForbiddenPage";

import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  ...getStandardButtonStyles(theme),
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderRadius: 16,
    backgroundColor: theme.palette.type === 'dark' ? '#2A2D32 !important' : theme.palette.background.paper,
  },
  textRight: {
    textAlign: "right",
  },
  tabPanelsContainer: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    marginBottom: 12,
  },
}));

const initialSettings = {
  messageInterval: 300,
  longerIntervalAfter: 10,
  greaterInterval: 600,
  variables: [],
  sabado: "false",
  domingo: "false",
  startHour: "09:00",
  endHour: "18:00"
};

const CampaignsConfig = () => {
  const classes = useStyles();
  const history = useHistory();

  const [settings, setSettings] = useState(initialSettings);
  const [showVariablesForm, setShowVariablesForm] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [selectedKey, setSelectedKey] = useState(null);
  const [variable, setVariable] = useState({ key: "", value: "" });
  const { user, socket } = useContext(AuthContext);

  const [sabado, setSabado] = React.useState(false);
  const [domingo, setDomingo] = React.useState(false);

  const [startHour, setStartHour] = useState("08:00");
  const [endHour, setEndHour] = useState("19:00");

  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);
      if (!planConfigs.plan?.useCampaigns) {
        toast.error(i18n.t("toastError.permissionDenied"));
        setTimeout(() => {
          history.push(`/`)
        }, 1000);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    api.get("/campaign-settings").then(({ data }) => {
      const settingsList = [];
      console.log(data)
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((item) => {
          let val = item.value;
          if (item.key === "variables") {
            try { val = JSON.parse(val); } catch (e) { val = []; }
          } else if (["messageInterval", "longerIntervalAfter", "greaterInterval"].includes(item.key)) {
            val = Number(val);
          }
          settingsList.push([item.key, val]);
          if (item.key === "sabado") setSabado(item?.value === "true");
          if (item.key === "domingo") setDomingo(item?.value === "true");
          if (item.key === "startHour") setStartHour(item?.value);
          if (item.key === "endHour") setEndHour(item?.value);

        });
        setSettings(prev => ({ ...prev, ...Object.fromEntries(settingsList) }));
      }
    });
  }, []);

  const handleOnChangeVariable = (e) => {
    if (e.target.value !== null) {
      const changedProp = {};
      changedProp[e.target.name] = e.target.value;
      setVariable((prev) => ({ ...prev, ...changedProp }));
    }
  };

  const handleOnChangeSettings = (e) => {
    const changedProp = {};
    changedProp[e.target.name] = e.target.value;
    setSettings((prev) => ({ ...prev, ...changedProp }));
    if (e.target.name === "aiProvider") {
      // setAiModels([]);
    }
  };

  const addVariable = () => {
    setSettings((prev) => {
      if (!Array.isArray(prev.variables)) {
        // Lidar com o caso em que prev.variables não é um array
        return { ...prev, variables: [Object.assign({}, variable)] };
      }
      const variablesExists = settings.variables.filter(
        (v) => v.key === variable.key
      );
      const variables = prev.variables;
      if (variablesExists.length === 0) {
        variables.push(Object.assign({}, variable));
        setVariable({ key: "", value: "" });
      }
      return { ...prev, variables };
    });
  };

  const removeVariable = () => {
    const newList = settings.variables.filter((v) => v.key !== selectedKey);
    setSettings((prev) => ({ ...prev, variables: newList }));
    setSelectedKey(null);
  };

  const saveSettings = async () => {
    if (
      settings.longerIntervalAfter > 0 &&
      settings.greaterInterval <= settings.messageInterval
    ) {
      toast.error("El 'Intervalo de Envío Mayor' debe ser estrictamente superior al 'Intervalo de Disparo Aleatorio'.");
      return;
    }
    await api.post("/campaign-settings", { settings });
    toast.success(i18n.t("campaignsConfig.success"));
  };

  const handleChange = (event) => {
    if (event.target.name === "sabado") {
      setSabado(event.target.checked);
    }
    if (event.target.name === "domingo") {
      setDomingo(event.target.checked);
    }
  };

  const handleSaveTimeMass = async () => {
    let settings = {
      sabado: sabado,
      domingo: domingo,
      startHour: startHour,
      endHour: endHour
    }

    try {
      await api.post(`/campaign-settings/`, { settings });

      toast.success(i18n.t("settings.success.saved"));
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <MainContainer>
      <ConfirmationModal
        title={i18n.t("campaigns.confirmationModal.deleteTitle")}
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onConfirm={removeVariable}
      >
        {i18n.t("campaigns.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      {
        user.profile === "user" && user?.showCampaign === "disabled" ?
          <ForbiddenPage />
          :
          <>
            <Paper className={classes.mainPaper} variant="outlined">
              <MainHeader>
                <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                  <PageHelpGuide
                    helpData={CAMPAIGNS_CONFIG_HELP_DATA}
                    tooltipText="Guía y Ayuda de Configuraciones de Campaña (Haz clic para ver)"
                  />
                  <Title>{i18n.t("campaignsConfig.title")}</Title>
                </div>
              </MainHeader>

              {/* <Typography component={"h1"}>Período de Disparo das Campanhas &nbsp;</Typography>
        <Paper className={classes.paper}>
          <TextField
            id="buttonText"
            label="Começar o envio que hora?"
            margin="dense"
            variant="outlined"
            fullWidth
            value={startHour}
            onChange={(e) => setStartHour(e.target.value)}
            style={{ marginRight: "10px" }}
          />

          <TextField
            id="buttonText"
            label="Terminar o envio que hora?"
            margin="dense"
            variant="outlined"
            fullWidth
            value={endHour}
            onChange={(e) => setEndHour(e.target.value)}
            style={{ marginRight: "10px" }}
          />

          <FormControlLabel
            control={<Checkbox checked={sabado} onChange={handleChange} name="sabado" />}
            label="Sábado"
          />

          <FormControlLabel
            control={<Checkbox checked={domingo} onChange={handleChange} name="domingo" />}
            label="Domigo"
          />

          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => {
              handleSaveTimeMass();
            }}
            style={{ marginRight: "10px" }}
          >
            Salvar
          </Button>

        </Paper> */}

              <Box className={classes.tabPanelsContainer} style={{ padding: "16px 24px" }}>
                <Grid spacing={2} container alignItems="flex-start">
                  <Grid xs={12} item>
                    <Typography component={"h1"} variant="subtitle1" style={{ fontWeight: 600, marginBottom: 4 }}>
                      {i18n.t("campaignsConfig.interval")} &nbsp;
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl
                      variant="outlined"
                      size="small"
                      className={classes.formControl}
                      fullWidth
                    >
                      <InputLabel id="messageInterval-label" margin="dense">
                        {i18n.t("campaigns.settings.randomInterval")}
                      </InputLabel>
                      <Select
                        name="messageInterval"
                        id="messageInterval"
                        labelId="messageInterval-label"
                        label={i18n.t("campaigns.settings.randomInterval")}
                        value={settings.messageInterval}
                        margin="dense"
                        onChange={(e) => handleOnChangeSettings(e)}
                      >
                        <MenuItem value={120}>120 {i18n.t("campaigns.settings.seconds")}</MenuItem>
                        <MenuItem value={150}>150 {i18n.t("campaigns.settings.seconds")} (2.5 min)</MenuItem>
                        <MenuItem value={180}>180 {i18n.t("campaigns.settings.seconds")} (3 min)</MenuItem>
                        <MenuItem value={240}>240 {i18n.t("campaigns.settings.seconds")} (4 min)</MenuItem>
                        <MenuItem value={300}>300 {i18n.t("campaigns.settings.seconds")} (5 min)</MenuItem>
                        <MenuItem value={360}>360 {i18n.t("campaigns.settings.seconds")} (6 min)</MenuItem>
                        <MenuItem value={480}>480 {i18n.t("campaigns.settings.seconds")} (8 min)</MenuItem>
                        <MenuItem value={600}>600 {i18n.t("campaigns.settings.seconds")} (10 min)</MenuItem>
                        <MenuItem value={1200}>1200 {i18n.t("campaigns.settings.seconds")} (20 min)</MenuItem>
                        <MenuItem value={1800}>1800 {i18n.t("campaigns.settings.seconds")} (30 min)</MenuItem>
                      </Select>
                      <FormHelperText>
                        Tiempo base entre cada mensaje (Mínimo real garantizado: 2 min).
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl
                      variant="outlined"
                      size="small"
                      className={classes.formControl}
                      fullWidth
                    >
                      <InputLabel id="longerIntervalAfter-label" margin="dense">
                        {i18n.t("campaigns.settings.intervalGapAfter")}
                      </InputLabel>
                      <Select
                        name="longerIntervalAfter"
                        id="longerIntervalAfter"
                        labelId="longerIntervalAfter-label"
                        label={i18n.t("campaigns.settings.intervalGapAfter")}
                        value={settings.longerIntervalAfter}
                        margin="dense"
                        onChange={(e) => handleOnChangeSettings(e)}
                      >
                        <MenuItem value={0}>{i18n.t("campaigns.settings.undefined")}</MenuItem>
                        <MenuItem value={5}>5 {i18n.t("campaigns.settings.messages")}</MenuItem>
                        <MenuItem value={10}>10 {i18n.t("campaigns.settings.messages")}</MenuItem>
                        <MenuItem value={15}>15 {i18n.t("campaigns.settings.messages")}</MenuItem>
                        <MenuItem value={20}>20 {i18n.t("campaigns.settings.messages")}</MenuItem>
                        <MenuItem value={30}>30 {i18n.t("campaigns.settings.messages")}</MenuItem>
                        <MenuItem value={40}>40 {i18n.t("campaigns.settings.messages")}</MenuItem>
                        <MenuItem value={50}>50 {i18n.t("campaigns.settings.messages")}</MenuItem>
                        <MenuItem value={60}>60 {i18n.t("campaigns.settings.messages")}</MenuItem>
                      </Select>
                      <FormHelperText>
                        Pausar al alcanzar esta cantidad de mensajes seguidos.
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl
                      variant="outlined"
                      size="small"
                      className={classes.formControl}
                      fullWidth
                    >
                      <InputLabel id="greaterInterval-label" margin="dense">
                        {i18n.t("campaigns.settings.laggerTriggerRange")}
                      </InputLabel>
                      <Select
                        name="greaterInterval"
                        id="greaterInterval"
                        labelId="greaterInterval-label"
                        label={i18n.t("campaigns.settings.laggerTriggerRange")}
                        value={settings.greaterInterval}
                        margin="dense"
                        onChange={(e) => handleOnChangeSettings(e)}
                      >
                        <MenuItem value={120}>120 {i18n.t("campaigns.settings.seconds")}</MenuItem>
                        <MenuItem value={130}>130 {i18n.t("campaigns.settings.seconds")}</MenuItem>
                        <MenuItem value={140}>140 {i18n.t("campaigns.settings.seconds")}</MenuItem>
                        <MenuItem value={150}>150 {i18n.t("campaigns.settings.seconds")} (2.5 min)</MenuItem>
                        <MenuItem value={160}>160 {i18n.t("campaigns.settings.seconds")}</MenuItem>
                        <MenuItem value={170}>170 {i18n.t("campaigns.settings.seconds")}</MenuItem>
                        <MenuItem value={180}>180 {i18n.t("campaigns.settings.seconds")} (3 min)</MenuItem>
                        <MenuItem value={240}>240 {i18n.t("campaigns.settings.seconds")} (4 min)</MenuItem>
                        <MenuItem value={300}>300 {i18n.t("campaigns.settings.seconds")} (5 min)</MenuItem>
                        <MenuItem value={480}>480 {i18n.t("campaigns.settings.seconds")} (8 min)</MenuItem>
                        <MenuItem value={600}>600 {i18n.t("campaigns.settings.seconds")} (10 min)</MenuItem>
                        <MenuItem value={900}>900 {i18n.t("campaigns.settings.seconds")} (15 min)</MenuItem>
                        <MenuItem value={1200}>1200 {i18n.t("campaigns.settings.seconds")} (20 min)</MenuItem>
                        <MenuItem value={1800}>1800 {i18n.t("campaigns.settings.seconds")} (30 min)</MenuItem>
                      </Select>
                      <FormHelperText>
                        Pausa larga inicial. Cada vez que la campaña envíe el bloque de mensajes configurado a la izquierda, esta pausa sumará 1 minuto extra de forma automática al Intervalo de Envío Mayor (simulando cansancio).
                      </FormHelperText>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={2} style={{ display: 'flex', alignItems: 'flex-start', paddingTop: 8 }}>
                    <Button
                      onClick={saveSettings}
                      className={classes.applyButton}
                      variant="contained"
                      style={{ marginTop: 0 }}
                    >
                      {i18n.t("campaignsConfig.save")}
                    </Button>
                  </Grid>

                  {/* [ANTIGRAVITY] Plan 1247: Panel Informativo de Calentamiento Progresivo (Tiers Anti-Baneo) */}
                  <Grid xs={12} item style={{ marginTop: 24 }}>
                    <Paper style={{ padding: 20, borderRadius: 12, border: '1px solid rgba(59, 130, 246, 0.3)', backgroundColor: 'rgba(30, 41, 59, 0.25)' }}>
                      <Box display="flex" alignItems="center" marginBottom={1}>
                        <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                          {i18n.t("campaigns.dialog.form.antiBanTiersTitle")}
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                        {i18n.t("campaigns.dialog.form.antiBanTiersDesc")}
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={3}>
                          <Paper variant="outlined" style={{ padding: 14, height: '100%', borderRadius: 8, borderColor: 'rgba(59, 130, 246, 0.4)' }}>
                            <Box display="flex" alignItems="center" justifyContent="space-between" marginBottom={1}>
                              <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#60a5fa' }}>
                                {i18n.t("campaigns.dialog.form.tier1Title")}
                              </Typography>
                              <span style={{ fontSize: '0.75rem', fontWeight: 'bold', padding: '2px 8px', borderRadius: 12, backgroundColor: 'rgba(59, 130, 246, 0.15)', color: '#60a5fa' }}>
                                30 / día
                              </span>
                            </Box>
                            <Typography variant="caption" color="textSecondary">
                              {i18n.t("campaigns.dialog.form.tier1Desc")}
                            </Typography>
                          </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                          <Paper variant="outlined" style={{ padding: 14, height: '100%', borderRadius: 8, borderColor: 'rgba(16, 185, 129, 0.4)' }}>
                            <Box display="flex" alignItems="center" justifyContent="space-between" marginBottom={1}>
                              <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#34d399' }}>
                                {i18n.t("campaigns.dialog.form.tier2Title")}
                              </Typography>
                              <span style={{ fontSize: '0.75rem', fontWeight: 'bold', padding: '2px 8px', borderRadius: 12, backgroundColor: 'rgba(16, 185, 129, 0.15)', color: '#34d399' }}>
                                75 / día
                              </span>
                            </Box>
                            <Typography variant="caption" color="textSecondary">
                              {i18n.t("campaigns.dialog.form.tier2Desc")}
                            </Typography>
                          </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                          <Paper variant="outlined" style={{ padding: 14, height: '100%', borderRadius: 8, borderColor: 'rgba(245, 158, 11, 0.4)' }}>
                            <Box display="flex" alignItems="center" justifyContent="space-between" marginBottom={1}>
                              <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#fbbf24' }}>
                                {i18n.t("campaigns.dialog.form.tier3Title")}
                              </Typography>
                              <span style={{ fontSize: '0.75rem', fontWeight: 'bold', padding: '2px 8px', borderRadius: 12, backgroundColor: 'rgba(245, 158, 11, 0.15)', color: '#fbbf24' }}>
                                150 / día
                              </span>
                            </Box>
                            <Typography variant="caption" color="textSecondary">
                              {i18n.t("campaigns.dialog.form.tier3Desc")}
                            </Typography>
                          </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                          <Paper variant="outlined" style={{ padding: 14, height: '100%', borderRadius: 8, borderColor: 'rgba(139, 92, 246, 0.4)' }}>
                            <Box display="flex" alignItems="center" justifyContent="space-between" marginBottom={1}>
                              <Typography variant="subtitle2" style={{ fontWeight: 'bold', color: '#a78bfa' }}>
                                {i18n.t("campaigns.dialog.form.tier4Title")}
                              </Typography>
                              <span style={{ fontSize: '0.75rem', fontWeight: 'bold', padding: '2px 8px', borderRadius: 12, backgroundColor: 'rgba(139, 92, 246, 0.15)', color: '#a78bfa' }}>
                                250 / día
                              </span>
                            </Box>
                            <Typography variant="caption" color="textSecondary">
                              {i18n.t("campaigns.dialog.form.tier4Desc")}
                            </Typography>
                          </Paper>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>


                </Grid>
              </Box>
            </Paper>
          </>}
    </MainContainer>
  );
};

export default CampaignsConfig;
